export const REQUIRED_FIELD_MISSING_ERROR = 'REQUIRED_FIELD_MISSING';
export const FIELD_VALIDATION_FAILED = 'FIELD_VALIDATION_FAILED';
export const FORM_NOT_FOUND = 'FORM_NOT_FOUND';
export const BAD_REQUEST = 'BAD_REQUEST';
export const PROJECT_NOT_FOUND = 'PROJECT_NOT_FOUND';
export const VIEW_PROJECT_PERMISSION_ERROR = 'VIEW_PROJECT_PERMISSION_ERROR';
export const INVALID_EMAIL = 'INVALID_EMAIL';
export const LOW_RECAPTCHA_SCORE = 'RETRY_RECAPTCHA';
export const BROWSER_ERROR = 'BROWSER_ERROR';
